import { setMessageFeedback } from 'store/messages'
import { store } from 'store/index'
import { FeedbackEnum } from 'types/chat-message'
import { captchaAxios } from 'api/config'

export const sendMessageFeedback = async ({ messageId, feedback }: { messageId: string; feedback: FeedbackEnum }) => {
  try {
    await captchaAxios.put(`chat-messages/${messageId}/feedback`, {
      feedback,
    })
    store.dispatch(setMessageFeedback({ messageId, feedback }))
  } catch (e) {
    console.error({ e })
  }
}
